import styled from 'styled-components'
import { colors } from 'Styled/variables'

export const CommentBlock = styled.div`
  color: ${colors.mainText};
  margin-bottom: 0px;
  text-align: left;
`

export const Title = styled.div`
  margin-top: 1rem;
  font-size: 10px;
  color: inherit;
  line-height: 15px;
`

export const Text = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: ${colors.mainText};
`
